<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "App",
	};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;400;600;700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200;400;600;700&display=swap');

	@import '@/assets/scss/colors';
	@import '@/assets/scss/styles';

	@import '~bootstrap';
	@import '~bootstrap-vue';
	@import "~vue-select/src/scss/vue-select";
</style>
